import React from "react";
import { BackgroundImage, HeaderComponent } from "../../FifthComponents";
import img from "../../fifthAssets/Images/contact-img.jpg"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import allPaths from "../../Config/paths"
import { centreOfExpertiesTabs } from "../../fifthUtils/constant";

const BackCentreExpertise = (props) => {
    const { selectedLanguage } = props;
    const history = useHistory()
    return (
        <div>
            <BackgroundImage screenName={selectedLanguage?.txt_back_centre_of_expertise} classForBg='fifth-des-experties-bg' {...props} />
            <HeaderComponent title={selectedLanguage?.txt_back_centre_of_expertise} lineClass='bg-gray' titleClass='color-blue' />
            <div className="fifth-des-contact-div">
                <div className="fifth-des-pediatric-text-div">
                    <p>
                        <b>{selectedLanguage?.txt_back_pain}</b> {selectedLanguage?.txt_back_pain_info}
                    </p>
                    <h2>
                        {selectedLanguage?.txt_signs_and_symptoms}
                    </h2>
                    <p>
                        {selectedLanguage?.txt_back_pain_symptoms}
                        <b>{selectedLanguage?.txt_amsterdam_clinics}</b> {selectedLanguage?.txt_back_pain_diagnosis}
                    </p>
                    <h2>
                        {selectedLanguage?.txt_care_path_includes}
                    </h2>
                    <ul>
                        <li>
                            {selectedLanguage?.txt_full_assessment_and_screening}
                        </li>
                        <li>
                            {selectedLanguage?.txt_comprehensive_diagnosis}
                        </li>
                        <li>
                            {selectedLanguage?.txt_second_opinion_dutch_expert}
                        </li>
                        <li>
                            {selectedLanguage?.txt_treatment_plan_supervised_by_experts}
                        </li>
                        <li>
                            {selectedLanguage?.txt_prevention_program}
                        </li>
                        <li>
                            {selectedLanguage?.txt_treatment_possibilities_netherlands}
                        </li>
                    </ul>
                </div>
                <div className="fifth-des-contact-img-div">
                    <img onClick={() => history?.push(allPaths?.FIFHTAPPOINTMENT)} src={img} alt="" />
                    <h2>
                        {selectedLanguage?.txt_physiotherapy_techniques_include}
                    </h2>
                    <div className="fifth-des-centre-expertise-tabs">
                        {
                            centreOfExpertiesTabs?.map((v, i) => {
                                return (
                                    <button>
                                        {v?.title}
                                    </button>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
export default BackCentreExpertise